import SpacerComponent, { SpacerProps } from '@/components/base/Spacer'

const Spacer = (props: SpacerProps) => {
  return <SpacerComponent {...props} />
}

export default Spacer
